import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { AppSvgIconComponent } from '@vallift/ngl';
import type { AnswerDetailSection } from '../../utils/form-submission-answer-display';

export interface AnswerDetailsPreviewOverlayData {
  sections: AnswerDetailSection[];
  summaryLabel?: string;
  onPointerEnter?: () => void;
  onPointerLeave?: () => void;
}

@Component({
  selector: 'app-answer-details-preview-overlay',
  standalone: true,
  imports: [AppSvgIconComponent],
  templateUrl: './answer-details-preview-overlay.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block',
    '(mouseenter)': 'onCardEnter()',
    '(mouseleave)': 'onCardLeave()',
  },
})
export class AnswerDetailsPreviewOverlayComponent {
  private readonly data = inject<AnswerDetailsPreviewOverlayData>(DIALOG_DATA);

  readonly sections = this.data.sections ?? [];
  readonly summaryLabel = this.data.summaryLabel?.trim() || '';

  onCardEnter(): void {
    this.data.onPointerEnter?.();
  }

  onCardLeave(): void {
    this.data.onPointerLeave?.();
  }
}
